import { render, staticRenderFns } from "./SoilSensorsViewTable.vue?vue&type=template&id=47d65e0b&scoped=true&lang=pug"
import script from "./SoilSensorsViewTable.vue?vue&type=script&lang=js"
export * from "./SoilSensorsViewTable.vue?vue&type=script&lang=js"
import style0 from "./SoilSensorsViewTable.vue?vue&type=style&index=0&id=47d65e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d65e0b",
  null
  
)

export default component.exports